// export const CORE_API_ENDPOINT = 'https://www.bainisysstg.com/core'
export const CORE_API_ENDPOINT = '/core'
export const O365_API_ENDPOINT = '/o365'
export const NOTI_API_ENDPOINT = '/notification'



// WEBPACK FOOTER //
// ./src/lib/api.js